// extracted by mini-css-extract-plugin
module.exports = {"Container":"SideMenuDownloadView_Container__UDe1V","TitleText":"SideMenuDownloadView_TitleText__cqH_2","ToggleSwitch":"SideMenuDownloadView_ToggleSwitch__bfuez"};